import React from 'react';
import ContainerTemplateGallery from '../common/ContainerTemplateGallery';

// Dispositions de conteneur prêtes à poser : onglet à part, et non un bloc de
// l'onglet Éléments. Ce sont deux gestes différents — poser une structure
// (colonnes, lignes) contre poser une box — et les empiler dans le même
// panneau allongeait la liste des éléments au point qu'il fallait défiler pour
// atteindre les variables.
//
// Ajout par glisser seulement, pas au clic : on vise toujours l'emplacement.
const LayoutsPanel = () => {
  return (
    <div style={{ padding: 16 }}>
      <div
        style={{
          fontSize: 11,
          lineHeight: 1.4,
          color: 'rgba(11, 34, 57, 0.6)',
          marginBottom: 14,
        }}
      >
        Glissez une disposition dans le document.
      </div>
      <ContainerTemplateGallery
        columnsCount={2}
        previewHeight={38}
        showTemplateLabels
      />
    </div>
  );
};

export default LayoutsPanel;
